__turbopack_context__.v({
  "careers": "Careers-module-scss-module__NPImHW__careers",
  "empty-state": "Careers-module-scss-module__NPImHW__empty-state",
  "hero": "Careers-module-scss-module__NPImHW__hero",
  "job": "Careers-module-scss-module__NPImHW__job",
  "jobs": "Careers-module-scss-module__NPImHW__jobs",
  "jobs-wrapper": "Careers-module-scss-module__NPImHW__jobs-wrapper",
  "shape": "Careers-module-scss-module__NPImHW__shape",
});
